import React, { useState, useEffect, useContext } from 'react'

const NewContext = React.createContext()

// Creating Custom Hooks
export function useMyHook() {
    return useContext(NewContext)
}

export default function NewContextProvider({ children }) {
    // Setting up State Values
    const [collapse, setCollapse] = useState(false),
        [windowSize, setWindowSize] = useState(window.innerWidth)

    // Function to detect the width of the viewport
    useEffect(() => {
        const getWindowSize = () => {
            setWindowSize(window.innerWidth)
        }
        // Run function on window resize
        window.addEventListener('resize', getWindowSize)
        //  Cleanup Function
        return () => window.removeEventListener('resize', getWindowSize)
    }, [windowSize])

    // Function to handle open/close of header menu
    const toggleMenuCollapse = () => {
        setCollapse((prevState) => {
            return !prevState
        })
    }

    return (
        <NewContext.Provider value={{ collapse, toggleMenuCollapse, windowSize }}>
           { children } 
        </NewContext.Provider>
    )
}